import { render, staticRenderFns } from "./korean_curriculum.vue?vue&type=template&id=64434e30&scoped=true"
import script from "./korean_curriculum.vue?vue&type=script&lang=js"
export * from "./korean_curriculum.vue?vue&type=script&lang=js"
import style0 from "./korean_curriculum.vue?vue&type=style&index=0&id=64434e30&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64434e30",
  null
  
)

export default component.exports